export * from './renderer/StylerRegs.js';